<template>
    <v-card class="pa-2 pb-3">
        <v-card-title class="headline px-3">Add Gifts</v-card-title>

        <div v-if="!showConfirmView">
            <v-card style="background-color: #5cb860" class="mt-2 mx-3">
                <v-layout row>
                    <div
                        class="pa-3 pt-4 mt-1 display-1 font-weight-light"
                        style="width: 27%; color: #fff"
                    >
                        Default Values
                    </div>
                    <v-card-actions
                        class="pb-3 my-2 mx-3"
                        style="width: 71%; background-color: #fff; border-radius: 3px;"
                    >
                        <v-layout row>
                            <v-select
                                style="width: 25%;"
                                class="mr-3 ml-4"
                                :items="getGiftTypes()"
                                label="Type"
                                v-model="giftType"
                                @change="updateGiftType"
                                hide-details
                            ></v-select>
                            <v-text-field
                                style="width: 15%;"
                                class="mr-2"
                                hide-details
                                type="number"
                                label="Quantity"
                                v-model="quantity"
                                @input="updateQuantity"
                            ></v-text-field>
                            <v-text-field
                                style="width: 15%;"
                                class="mr-2"
                                hide-details
                                type="number"
                                label="Order Number"
                                v-model="orderNumber"
                                @input="updateOrderNumber"
                            ></v-text-field>
                            <v-text-field
                                style="width: 20%;"
                                class="mr-2"
                                hide-details
                                label="Note"
                                @input="updateNote"
                                v-model="note"
                            ></v-text-field>
                            <v-checkbox
                                style="width: 15%;"
                                class="mx-1"
                                label="Picked Up"
                                color="success"
                                hide-details
                                @change="updatePickedUp"
                                v-model="pickedUp"
                            ></v-checkbox>
                        </v-layout>
                    </v-card-actions>
                </v-layout>
            </v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-2 mt-3 scroll mx-2" style="height: 500px;">
                <div
                    class="headline font-weight-regular mb-4 text-xs-center"
                    v-if="!students.length"
                >
                    Please select students
                </div>
                <div v-for="(student, index) in students">
                    <v-layout row class="mb-2 mt-0">
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <v-select
                            style="width: 25%;"
                            class="mx-2 pt-4"
                            :items="getGiftTypes()"
                            label="Type"
                            v-model="student.giftType"
                            ref="giftType"
                        ></v-select>
                        <v-text-field
                            style="width: 15%;"
                            class="mx-2 pt-4"
                            type="number"
                            label="Quantity"
                            :rules="quantityRules"
                            v-model="student.quantity"
                            ref="quantity"
                        ></v-text-field>
                        <v-text-field
                            style="width: 15%;"
                            class="mx-2 pt-4"
                            type="number"
                            label="Order Number"
                            v-model="student.orderNumber"
                        ></v-text-field>
                        <v-text-field
                            style="width: 20%;"
                            class="mx-2 pt-4"
                            hide-details
                            label="Note"
                            v-model="student.note"
                        ></v-text-field>
                        <v-checkbox
                            style="width: 15%;"
                            class="mx-2 pt-4"
                            label="Picked Up"
                            color="success"
                            hide-details
                            v-model="student.pickedUp"
                        ></v-checkbox> </v-layout
                    ><v-divider
                        class="mt-0 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn
                    :disabled="
                        !students.length || !students.some(s => s.giftType)
                    "
                    :loading="processing"
                    color="success"
                    @click="continueToConfirm()"
                >
                    Continue
                </v-btn>
            </v-card-actions>
        </div>

        <div v-else>
            <div
                class="headline font-weight-regular text-warning mb-4 text-xs-center"
            >
                Please confirm gift details below
            </div>
            <v-card-text class="pa-2 mt-3 scroll" style="height: 500px;">
                <div
                    height="50"
                    v-for="(student, index) in students.filter(s => s.giftType)"
                >
                    <v-layout row class="font-weight-regular">
                        <div style="width: 40%;" class="mr-3">
                            <div class="font-weight-bold">
                                {{ student.fullName }}
                            </div>
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Grade:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.grade }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Branch:
                                </div>
                                <div class="font-weight-light pr-2">
                                    {{ student.branch }}
                                </div>
                                <div class="font-weight-regular pr-1">
                                    Class:
                                </div>
                                <div class="font-weight-light ">
                                    {{ student.class }}
                                </div></v-layout
                            >
                            <v-layout row
                                ><div class="font-weight-regular pr-1">
                                    Teacher:
                                </div>
                                <div class="font-weight-light">
                                    {{ student.teacher }}
                                </div></v-layout
                            >
                        </div>
                        <div
                            style="width: 25%; text-align: right;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.giftType }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.quantity }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{ student.orderNumber }}
                        </div>
                        <div
                            style="width: 20%;"
                            class="mx-3 text-xs-center pt-4"
                        >
                            {{
                                student.pickedUp ? "Picked Up" : "Not Picked Up"
                            }}
                        </div>
                    </v-layout>
                    <v-divider
                        class="mt-2 mb-2 pb-1"
                        v-if="index + 1 < students.length"
                        :key="index"
                    ></v-divider>
                </div>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn dark color="default" @click="closeDialog()"
                    >Cancel</v-btn
                >
                <v-btn dark color="default" @click="showConfirmView = false"
                    >Back</v-btn
                >
                <v-btn :loading="processing" color="success" @click="save()">
                    Save Gifts
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
import { toISOLocal, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        students: Array,
        reloadGrid: Function,
        closeNewGiftDialog: Function,
        getDomain: Function,
        setup: Object
    },
    components: {},
    data() {
        return {
            processing: false,
            showConfirmView: false,
            quantity: 1,
            orderNumber: "",
            pickedUp: false,
            note: "",
            giftType: "",
            giftSetups: [],

            required: [v => !!v || "Required"],
            quantityRules: [
                v => !!v || "Required",
                v => !v || +v > 0 || "Must be at least 1"
            ]
        };
    },
    async created() {
        await this.loadGiftSetups();
    },
    watch: {},
    computed: {},
    methods: {
        async loadGiftSetups() {
            const giftSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getGiftSetup"
            );

            this.giftSetups = giftSetups;
        },
        closeDialog() {
            this.giftType = "";
            this.quantity = 1;
            this.orderNumber = "";
            this.note = "";
            this.pickedUp = false;
            this.showConfirmView = false;

            this.closeNewGiftDialog();
        },
        getGiftTypes() {
            if (!this.giftSetups) return [];

            return this.giftSetups.map(
                g => g.description + " - " + formatCurrency(g.value)
            );
        },
        getGiftID(type) {
            if (!this.giftSetups) return "";

            const value = type.split("-")[0].trim();

            const setup = this.giftSetups.find(g => g.description == value);

            return setup.giftID;
        },
        updateGiftType(value) {
            this.students.forEach(student => (student.giftType = value));
        },
        updateQuantity(value) {
            this.students.forEach(student => (student.quantity = value));
        },
        updateOrderNumber(value) {
            this.students.forEach(student => (student.orderNumber = value));
        },
        updateNote(value) {
            this.students.forEach(student => (student.note = value));
        },
        updatePickedUp(value) {
            this.students.forEach(student => (student.pickedUp = value));
        },
        validate() {
            const quantityValidation = this.$refs.quantity
                .map(a => a.validate(true))
                .every(Boolean);
            // const giftTypeValidation = this.$refs.giftType
            //     .map(a => a.validate(true))
            //     .every(Boolean);

            return [quantityValidation].every(Boolean);
        },
        continueToConfirm() {
            if (!this.validate()) return;

            this.showConfirmView = true;
        },
        async save() {
            this.processing = true;

            const today = moment().format("YYYY-MM-DD HH:mm:ss");

            const data = this.students
                .filter(s => s.giftType)
                .map(student => {
                    return {
                        id: 0,
                        year: this.setup.currentYear,
                        dateEntered: today,
                        quantity: student.quantity,
                        isPickedUp: student.pickedUp,
                        studentID: student.studentID,
                        orderNumber: student.orderNumber,
                        notes: student.note,
                        giftID: this.getGiftID(student.giftType),
                        enteredBy: this.$store.state.authentication.user,
                        dateLastUpdated: null,
                        lastUpdatedBy: null
                    };
                });
            try {
                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/postInBulk",
                    data
                );
                this.processing = false;
                this.$notify({
                    text: "Gifts Saved",
                    group: "notification",
                    type: "success"
                });
                this.closeDialog();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        }
    }
};
</script>
<style>
.scroll {
    overflow-y: auto;
}
</style>
